import { useContext } from "react"
import { MediaContext } from "../contexts/MediaContext"

export const useMediaContext = () => {
    return useContext(MediaContext);
}